<template>
  <v-autocomplete
    :items="todoGoalList"
    item-value="id"
    item-text="name"
    v-model="todoGoalIdValue"
    label="Goal"
    :clearable="!readonly"
    :readonly="readonly"
    :append-icon="readonly ? null : '$dropdown'"
    outlined
  ></v-autocomplete>
</template>

<script>

export default {
  props: [
    'todoGoalId',
    'isRequired',
    'todoGoalList',
    'readonly'
  ],
  computed: {
    todoGoalIdValue: {
      get () {
        return this.todoGoalId
      },
      set (newValue) {
        this.$emit('todoGoalIdChange', newValue)
      }
    }
  }
}
</script>
